/**
 * usePanelState Hook
 * Manages all panel/modal visibility toggles for the DAW workspace.
 * Extracted from DAWWorkspace.jsx to reduce component complexity.
 */

import { useState } from 'react';

export const usePanelState = () => {
  // Main panels
  const [showMixer, setShowMixer] = useState(true);
  const [showEffects, setShowEffects] = useState(false);
  const [showChordWizard, setShowChordWizard] = useState(false);
  const [showChordTrack, setShowChordTrack] = useState(true);
  const [showSmartTempo, setShowSmartTempo] = useState(false);
  const [showQuickStart, setShowQuickStart] = useState(false);
  const [isSimplifiedMode, setIsSimplifiedMode] = useState(false);
  const [showAIMixing, setShowAIMixing] = useState(false);
  const [showCollaboration, setShowCollaboration] = useState(false);
  const [showSessionManager, setShowSessionManager] = useState(false);
  const [showAdvancedEffects, setShowAdvancedEffects] = useState(false);
  const [showEffectPresetsBrowser, setShowEffectPresetsBrowser] = useState(false);
  const [showMastering, setShowMastering] = useState(false);
  const [showAIMastering, setShowAIMastering] = useState(false);
  const [showAIMixAssistant, setShowAIMixAssistant] = useState(false);
  const [showAIChordGenerator, setShowAIChordGenerator] = useState(false);
  const [showAILyricAssistant, setShowAILyricAssistant] = useState(false);
  const [showAIDrumGenerator, setShowAIDrumGenerator] = useState(false);
  const [showVideoSync, setShowVideoSync] = useState(false);
  const [showSampleLibrary, setShowSampleLibrary] = useState(false);
  const [showPluginRack, setShowPluginRack] = useState(false);
  const [showPluginBrowser, setShowPluginBrowser] = useState(false);
  const [showPluginMarketplace, setShowPluginMarketplace] = useState(false);
  const [showChainPresets, setShowChainPresets] = useState(false);
  const [showBatchExporter, setShowBatchExporter] = useState(false);
  const [showKeyboardShortcuts, setShowKeyboardShortcuts] = useState(false);
  const [showAutomation, setShowAutomation] = useState(false);
  const [showInstruments, setShowInstruments] = useState(false);
  const [showMIDIPanel, setShowMIDIPanel] = useState(false);
  const [showMarkersPanel, setShowMarkersPanel] = useState(false);
  const [showJamSessionModal, setShowJamSessionModal] = useState(false);
  const [showJamSessionPanel, setShowJamSessionPanel] = useState(false);
  const [showTemplateSelector, setShowTemplateSelector] = useState(false);

  return {
    showMixer, setShowMixer,
    showEffects, setShowEffects,
    showChordWizard, setShowChordWizard,
    showChordTrack, setShowChordTrack,
    showSmartTempo, setShowSmartTempo,
    showQuickStart, setShowQuickStart,
    isSimplifiedMode, setIsSimplifiedMode,
    showAIMixing, setShowAIMixing,
    showCollaboration, setShowCollaboration,
    showSessionManager, setShowSessionManager,
    showAdvancedEffects, setShowAdvancedEffects,
    showEffectPresetsBrowser, setShowEffectPresetsBrowser,
    showMastering, setShowMastering,
    showAIMastering, setShowAIMastering,
    showAIMixAssistant, setShowAIMixAssistant,
    showAIChordGenerator, setShowAIChordGenerator,
    showAILyricAssistant, setShowAILyricAssistant,
    showAIDrumGenerator, setShowAIDrumGenerator,
    showVideoSync, setShowVideoSync,
    showSampleLibrary, setShowSampleLibrary,
    showPluginRack, setShowPluginRack,
    showPluginBrowser, setShowPluginBrowser,
    showPluginMarketplace, setShowPluginMarketplace,
    showChainPresets, setShowChainPresets,
    showBatchExporter, setShowBatchExporter,
    showKeyboardShortcuts, setShowKeyboardShortcuts,
    showAutomation, setShowAutomation,
    showInstruments, setShowInstruments,
    showMIDIPanel, setShowMIDIPanel,
    showMarkersPanel, setShowMarkersPanel,
    showJamSessionModal, setShowJamSessionModal,
    showJamSessionPanel, setShowJamSessionPanel,
    showTemplateSelector, setShowTemplateSelector,
  };
};

export default usePanelState;
